import { schema } from "normalizr";
import { UNIT_TYPE_SCHEMA } from "./index";

export default new schema.Entity(UNIT_TYPE_SCHEMA);
